import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cargarZipApi } from "@/features/cargar-zip/services/cargar-zip.api";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";

/**
 * Mutation para procesar el ZIP · al éxito hidrata la solicitud
 * (que puede contener N CFDIs viables) y notifica según el outcome.
 *
 * Hay tres outcomes posibles:
 *   1. f6Autorizada + reglasAutorizadas → ZIP procesado OK.
 *   2. !f6Autorizada → RFCs receptor inconsistentes (decisión 67).
 *   3. f6Autorizada + !reglasAutorizadas → algunas RN fallaron en algún CFDI.
 */
export function useCargarZip(solicitudId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (zip: File) => cargarZipApi.cargar(solicitudId, zip),
    onSuccess: (r) => {
      qc.setQueryData(qk.solicitud(solicitudId), r.solicitud);
      if (r.f6Autorizada && r.reglasAutorizadas) {
        toastExito({ title: "ZIP procesado", message: `${r.cfdisViables} CFDIs cargados · organización ${r.solicitud.organizacion?.nombre ?? "—"}` });
      } else if (!r.f6Autorizada) {
        toastError({ title: "F6 rechazado", message: r.f6MotivoRechazo ?? "RFCs receptor inconsistentes" });
      } else {
        toastError({ title: "Reglas rechazadas", message: `${r.erroresReglas.length} reglas · revisa el detalle` });
      }
    },
    onError: (e) => toastError({ title: "Error", message: extractApiMessage(e, "Error subiendo ZIP") }),
  });
}
